













































import { Component, Vue, Inject } from "vue-property-decorator";
import Util from "../lib/util";
import Footer from "../components/Footer.vue";
import TenantSwitch from "../components/tenant-switch.vue";
import LanguageSwitch from "../components/language-switch.vue";
import iView from "iview";
import AbpBase from "../lib/abpbase";
import "@/assets/css/login.css";


@Component({
  components: { Footer, TenantSwitch, LanguageSwitch },
})
export default class Login extends AbpBase {
  loginModel = {
    userNameOrEmailAddress: "",
    password: "",
    rememberMe: false,
    tenantId: 0,
  };
  showChangeTenant: boolean = false;
  loading: boolean = false;
  //登录
  async login() {
    (this.$refs.loginform as any).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        this.$Message.loading({
          content: this.L("LoginPrompt"),
          duration: 6,
        });
        let res = await this.$store
          .dispatch({
            type: "app/login",
            data: this.loginModel,
          })
          .catch((err) => {
            this.loading = false;
            this.$Message.loading({
              content: err,
              duration: 0,
            });
            //console.log(err)
          });
        if (res.data.result.isSuccess) {
          await this.$store.dispatch("app/getCache").catch((err) => {
            this.loading = false;
          });
          sessionStorage.setItem(
            "rememberMe",
            this.loginModel.rememberMe ? "1" : "0"
          );
          location.reload();
        } else {
          this.loading = false;
          this.$Message.error({
            content: res.data.result.result,
            duration: 3,
          });
        }
        this.loading = false;
      }
    });
  }
  //通过手机号/用户/邮箱获取租户信息
  async getTenantList() {
    if (this.loginModel.userNameOrEmailAddress == null) {
      return;
    }
    this.$data.tenantlist = [];
    await this.$store
      .dispatch({
        type: "tenant/getTenantList",
        keyword: this.loginModel.userNameOrEmailAddress,
      })
      .then((val) => {
        console.log(val)
        if (val.length > 0) {
          val.forEach((ele) => {
            this.loginModel.tenantId = ele.id;
            if (ele.id > 1) {
              this.$data.tenantlist.push({
                id: ele.id,
                value: ele.value,
              });
            }
          });
        } else {
          this.loginModel.tenantId = 0;
          this.$data.tenantlist.push({
            id: 0,
            value: this.L("PleasChoose"),
          });
        }
      })
      .catch((err) => {
        this.$Modal.info({
          title: this.L("Tips"),
          content: err,
        });
      });
    let tid = Util.abp.multiTenancy.getTenantIdCookie();
    if (tid == null && this.$data.tenantlist.length > 0) {
      //this.loginModel.tenantId = tid;
      Util.abp.multiTenancy.setTenantIdCookie(this.loginModel.tenantId);
    } else if (tid != null) {
      let tidinfo = this.$data.tenantlist.filter((ele) => {
        return ele.id == tid;
      });
      if (tidinfo.length > 0) {
        this.loginModel.tenantId = tid;
      } else {
        Util.abp.multiTenancy.setTenantIdCookie(this.loginModel.tenantId);
      }
    } else {
      Util.abp.multiTenancy.setTenantIdCookie(undefined);
      (this.$refs.tenantSelect as any).clearSingleSelect();
    }
    //console.log(Util.abp.multiTenancy.getTenantIdCookie());
  }
  changeTenant() {
    Util.abp.multiTenancy.setTenantIdCookie(this.loginModel.tenantId);
  }
  get tenant() {
    //console.log(this.$store.state.session.tenant);
    return this.$store.state.session.tenant;
  }
  rules = {
    userNameOrEmailAddress: [
      { required: true, message: this.L("UserNameRequired"), trigger: "blur" },
    ],
    password: [
      { required: true, message: this.L("PasswordRequired"), trigger: "blur" },
    ],
  };
  data() {
    return {
      tenantlist: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
  created() { }
}
